import { createContext, useContext } from 'react';

import { AppPermissions } from './permissions';

export const PermissionsContext = createContext<AppPermissions>(undefined!);
export const usePermissions = () => useContext(PermissionsContext);
